module.exports = __webpack_public_path__ + "static/pop-up-f5701ebaaff5a001f62ef9e73a9ac83e.gif";